import UmlShapeWidgetBase from './UmlShapeWidgetBase';
import { JxTooltip, JxTooltipRowItemDescription } from '@jx';
import './UmlSeqParticipantWidget.css';

// Pure painter for UmlSeqParticipantShape — sequence-diagram lifeline header,
// no members/constructor. Same click-to-select + inline-rename as
// UmlClassWidget/UmlPackageWidget (rename lives in UmlShapeWidgetBase).
// isActor renders a UML stick-figure + name label instead of the header box
// (see CsSeqShapeFactory's synthetic external-caller participant). Plain
// shape.x/y rendering — the bottom duplicate row (linkedParticipantId set)
// is kept in sync with the TOP participant's x by CsSeqDiaRelationHandler
// at move-time, not re-derived here at render time.
class UmlSeqParticipantWidget extends UmlShapeWidgetBase {
    getMinSize() {
        return { width: 60, height: 40 };
    }

    getEditableZoneClassName() {
        return 'uml-seq-participant-widget-name';
    }

    getEditableInputClassName() {
        return 'uml-seq-participant-widget-name-input';
    }

    getEditableText() {
        return this.props.shape.name;
    }

    renderActor(shape) {
        return (
            <div
                className={`uml-seq-actor-widget${this.props.isSelected ? ' uml-selected' : ''}`}
                data-shape-id={shape.id}
                style={{ left: shape.x, top: shape.y, width: shape.w, height: shape.h, zIndex: this.props.stackIndex ?? shape.zIndex }}
                onMouseDown={this.handleDragMouseDown}
            >
                <svg className="uml-seq-actor-widget-figure" viewBox="0 0 24 24">
                    <circle cx="12" cy="5" r="4" />
                    <line x1="12" y1="9" x2="12" y2="17" />
                    <line x1="4" y1="12" x2="20" y2="12" />
                    <line x1="12" y1="17" x2="6" y2="23" />
                    <line x1="12" y1="17" x2="18" y2="23" />
                </svg>
                {this.renderEditableZone(shape.name)}
                {this.renderResizeHandles()}
            </div>
        );
    }

    render() {
        const shape = this.props.shape;
        const content = shape.isActor ? (
            this.renderActor(shape)
        ) : (
            <div
                className={`uml-seq-participant-widget${this.props.isSelected ? ' uml-selected' : ''}`}
                data-shape-id={shape.id}
                style={{ left: shape.x, top: shape.y, width: shape.w, height: shape.h, zIndex: this.props.stackIndex ?? shape.zIndex }}
                onMouseDown={this.handleDragMouseDown}
            >
                {this.renderEditableZone(shape.name)}
                {this.renderResizeHandles()}
            </div>
        );

        return (
            <JxTooltip followCursor title={<JxTooltipRowItemDescription label="Press D" value="Delete shape" />}>
                {content}
            </JxTooltip>
        );
    }
}

export default UmlSeqParticipantWidget;
